import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { ReactNode, useState } from 'react'

import { TableCell } from '@/ui/atoms/table/Table'
import { cn } from '@/ui/utils/style'

interface CollapsibleCellProps {
  children: [ReactNode, ReactNode]
  noHiddenColumns?: boolean
  rowAction?: ReactNode
}

export function CollapsibleCell({ children, noHiddenColumns, rowAction }: CollapsibleCellProps) {
  const [TriggerContent, Content] = children
  const [open, setOpen] = useState(false)

  return (
    <CollapsiblePrimitive.Root
      open={open}
      onOpenChange={(open) => {
        if (!noHiddenColumns) setOpen(open)
      }}
      asChild
    >
      <TableCell className="block w-full p-0">
        <div
          className={cn(
            'rounded-xl border border-white/[0.06] bg-[#111114] transition-colors',
            open && 'border-white/[0.1]',
          )}
        >
          <CollapsiblePrimitive.CollapsibleTrigger asChild>
            <div className="flex cursor-pointer items-center justify-between gap-4 p-4">
              <div className="flex min-w-0 flex-1 items-center gap-3">{TriggerContent}</div>

              {(!noHiddenColumns || rowAction) && (
                <div className="flex shrink-0 items-center gap-3">
                  {!noHiddenColumns && (
                    <button type="button" className="text-muted-foreground transition-colors hover:text-foreground">
                      {open ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                    </button>
                  )}
                  {rowAction && <div onClick={(e) => e.stopPropagation()}>{rowAction}</div>}
                </div>
              )}
            </div>
          </CollapsiblePrimitive.CollapsibleTrigger>
          <CollapsiblePrimitive.CollapsibleContent>
            <div className="border-white/[0.06] border-t px-4 pt-3 pb-4">
              <div className="flex flex-col gap-2">{Content}</div>
            </div>
          </CollapsiblePrimitive.CollapsibleContent>
        </div>
      </TableCell>
    </CollapsiblePrimitive.Root>
  )
}
